import {createSlice} from '@reduxjs/toolkit';
import {IOneStory} from '../../types'
import reducers from './reducers'
import extraReducers from './extraReducers'

export * from '../../thunk/storyTags';

const StoryTagsSlice = createSlice({
    name: "storyTags",
    initialState: {
        data: <Record<string,IOneStory>>{},
        status: null,
        error: null,
        queryParams: null,
        tagGroupsStatus: null,
        tagGroupsQueryParams: { page: 1, perPage: 25, total: 0 },
    },
    reducers,
    extraReducers
});
const {actions, reducer} = StoryTagsSlice
export const {setStoryTag, setStoryTags, clearFilters} = actions;
export {reducer};
